import React, { PureComponent } from 'react';
import { browserHistory } from 'react-router';

import { joinPath } from '@eventbrite/path-utils';

import { Divider } from '@eventbrite/eds-divider';
import { SelectField } from '@eventbrite/eds-input-field';
import {
    FINANCIAL_RELIEF_PATH,
    US_STATES_FOR_SELECT_FIELD,
} from '../../constants';
import { CaliforniaInfo } from '../USStates/CaliforniaInfo';
import { ColoradoInfo } from '../USStates/ColoradoInfo';
import { FloridaInfo } from '../USStates/FloridaInfo';
import { GeorgiaInfo } from '../USStates/GeorgiaInfo';
import { IllinoisInfo } from '../USStates/IllinoisInfo';
import { LouisianaInfo } from '../USStates/LouisianaInfo';
import { MaineInfo } from '../USStates/MaineInfo';
import { MarylandInfo } from '../USStates/MarylandInfo';
import { MassachusettsInfo } from '../USStates/MassachusettsInfo';
import { MichiganInfo } from '../USStates/MichiganInfo';
import { NewMexicoInfo } from '../USStates/NewMexicoInfo';
import { NewYorkInfo } from '../USStates/NewYorkInfo';
import { OregonInfo } from '../USStates/OregonInfo';
import { PennsylvaniaInfo } from '../USStates/PennsylvaniaInfo';
import { UtahInfo } from '../USStates/UtahInfo';
import { WashingtonInfo } from '../USStates/WashingtonInfo';
import { WisconsinInfo } from '../USStates/WisconsinInfo';

const STATE_MAP = {
    california: CaliforniaInfo,
    colorado: ColoradoInfo,
    florida: FloridaInfo,
    georgia: GeorgiaInfo,
    illinois: IllinoisInfo,
    louisiana: LouisianaInfo,
    maine: MaineInfo,
    maryland: MarylandInfo,
    massachussets: MassachusettsInfo,
    michigan: MichiganInfo,
    'new-mexico': NewMexicoInfo,
    'new-york': NewYorkInfo,
    oregon: OregonInfo,
    pennsylvania: PennsylvaniaInfo,
    utah: UtahInfo,
    washington: WashingtonInfo,
    wisconsin: WisconsinInfo,
};

const stateUrl = (state) =>
    FINANCIAL_RELIEF_PATH + '/united-states/' + state + '/';

const stateListForBots = () =>
    US_STATES_FOR_SELECT_FIELD.map((element) => (
        <span key={element.value}>
            <a className="eds-l-pad-right-2" href={stateUrl(element.value)}>
                {element.display}
            </a>
            <br />
        </span>
    ));

class UnitedStatesStateInfo extends PureComponent {
    state = {
        stateSelected: '',
    };

    componentDidMount() {
        const { defaultRegionSelected } = this.props;

        this.setState({
            stateSelected: defaultRegionSelected,
        });
    }

    _handleStateSelect = (stateSelected) => {
        this.setState({
            stateSelected,
        });

        browserHistory.push(
            FINANCIAL_RELIEF_PATH + '/united-states/' + stateSelected + '/',
        );
    };

    render() {
        const { defaultRegionSelected, isBot } = this.props;
        const { stateSelected } = this.state;

        let StateInfo;
        if (stateSelected || defaultRegionSelected) {
            StateInfo = STATE_MAP[stateSelected || defaultRegionSelected];
        }

        return (
            <div>
                <div className="eds-g-cell eds-g-cell-mn-4-12 eds-g-sm-cell-1-1 eds-l-pad-right-12">
                    <p className="eds-l-mar-bot-4 eds-text-hs">
                        <a name="state"></a>
                        State & Local Financial Relief
                    </p>
                    <p className="eds-l-mar-bot-4">
                        Other financial relief initiatives are available for
                        business in the following states:
                    </p>
                    <div className="covid-selector">
                        {!isBot && (
                            <SelectField
                                label="State"
                                placeholder="Select a state"
                                values={US_STATES_FOR_SELECT_FIELD}
                                onChange={this._handleStateSelect}
                                defaultValue={
                                    stateSelected || defaultRegionSelected
                                }
                            />
                        )}
                        {isBot && stateListForBots()}
                    </div>
                </div>
                <div className="eds-g-cell eds-g-cell-mn-8-12 eds-g-sm-cell-1-1 eds-text-bm">
                    <div className="covid-state-content">
                        {StateInfo && <StateInfo isBot={isBot} />}
                        {!StateInfo && (
                            <p>
                                Pick a State on the left to see your local
                                financial relief programs
                            </p>
                        )}
                    </div>
                    <div className="eds-l-mar-vert-16">
                        <Divider />
                    </div>
                </div>
            </div>
        );
    }
}

export default UnitedStatesStateInfo;
